import { TextInput, DateInput } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Col, Form as FormCore, Row } from 'reactstrap';
import { useValidations } from '../../../../../../../hooks/useValidations';
import { FinantialBlockTooltip } from './FinantialBlockTooltip';

export interface FormProps {
  planStatus: string;
  graduationGrade: string;
  degreeGrade?: string;
  distinctionRank: string;
  financialBlockade: boolean | null;
  date: string | undefined;
}

const dictPrefix = 'studentsDegreeStudent';

export function StudentSummary({
  planStatus,
  graduationGrade,
  degreeGrade,
  distinctionRank,
  financialBlockade,
  date,
}: FormProps) {
  const { msgValidations, rulesPatternDecimal } = useValidations();

  const { t } = useTranslation();

  const texts = useMemo(
    () => ({
      distinctionRankLabel: t(`${dictPrefix}.form.distinctionRank`),
      graduationGradeLabel: t(`${dictPrefix}.form.graduationGrade`),
      degreeGradeLabel: t(`${dictPrefix}.form.degreeGrade`),
      dateLabel: t(`${dictPrefix}.form.date`),
      button: t(`${dictPrefix}.form.action`),
      financialStatus: {
        description: (
          <Trans i18nKey={`${dictPrefix}.financialStatus.description`} />
        ),
        label: t(`${dictPrefix}.financialStatus.label`),
      },
      confirm: {
        title: t(`${dictPrefix}.confirm.title`),
        body: t(`${dictPrefix}.confirm.body`),
      },
      error: t(`${dictPrefix}.form.error`),
      success: t(`${dictPrefix}.form.success`),
    }),
    [t],
  );

  return (
    <>
      <FormCore>
        {planStatus === 'egresado' && (
          <FinantialBlockTooltip financialBlockade={financialBlockade} />
        )}
        <Row>
          <Col className="pb-3" xs={12} lg={5}>
            <TextInput
              name="distinctionRank"
              label={texts.distinctionRankLabel}
              value={distinctionRank}
              disabled
              rules={{
                required: msgValidations.required,
              }}
            />
          </Col>
          <Col className="pb-3" xs={12} lg={3}>
            {date ? (
              <TextInput
                name="date"
                label={texts.dateLabel}
                value={dayjs(date).format('DD/MM/YYYY')}
                disabled
              />
            ) : (
              <DateInput
                name="date"
                label={texts.dateLabel}
                value={date}
                disabled
              />
            )}
          </Col>
          <Col className="pb-3" xs={12} lg={2}>
            <TextInput
              name="graduationGrade"
              label={texts.graduationGradeLabel}
              value={graduationGrade}
              rules={{
                pattern: rulesPatternDecimal,
              }}
              disabled
            />
          </Col>
          <Col className="pb-3" xs={12} lg={2}>
            <TextInput
              name="degreeGrade"
              label={texts.degreeGradeLabel}
              value={degreeGrade}
              disabled
              rules={{
                pattern: rulesPatternDecimal,
              }}
            />
          </Col>
        </Row>
      </FormCore>
    </>
  );
}
